/* eslint-disable @typescript-eslint/no-empty-function */
import { get } from 'lodash';
import { XProps } from '../types/zoid';
import { useEffect, useState } from 'react';

const noop = (): void => {};

export type XPropEvents = Pick<
  XProps,
  | 'onDisplay'
  | 'onRendered'
  | 'onRender'
  | 'onClose'
  | 'onResize'
  | 'onFocus'
  | 'onError'
  | 'onProps'
>;

const xpropEventFallbacks = (): XPropEvents => ({
  onDisplay: noop,
  onRendered: noop,
  onRender: noop,
  onClose: noop,
  onResize: noop,
  onFocus: noop,
  onError: noop,
  onProps: noop,
});

const xpropFallbacks = (): XProps => ({
  ...xpropEventFallbacks(),
  tenant: '',
  initialRoute: null,
  onSaveLocations: async () => {},
  canViewLocationsOnboardingFiles: false,
});

const getXprops = (): XProps =>
  Object.assign({}, xpropFallbacks(), get(window, 'xprops'));

const useXProps = (): XProps => {
  const [xprops, setXprops] = useState(xpropFallbacks());
  useEffect(() => {
    setXprops(getXprops());
  }, [get(window, 'xprops.tenant')]);
  return xprops;
};

export { xpropEventFallbacks, xpropFallbacks, getXprops, useXProps };
